export type Ville =
  | 'Tunis' | 'Ariana' | 'Ben Arous' | 'La Manouba' | 'Nabeul' | 'Zaghouan'
  | 'Bizerte' | 'Béja' | 'Jendouba' | 'El Kef' | 'Siliana'
  | 'Sousse' | 'Monastir' | 'Mahdia' | 'Kairouan' | 'Kasserine' | 'Sidi Bouzid'
  | 'Sfax' | 'Gabès' | 'Medenine' | 'Tataouine' | 'Gafsa' | 'Tozeur' | 'Kebili';

export const villesEtRegions: Record<Ville, string[]> = {
  Tunis: [
    'Tunis Belvedere', 'Tunis', 'Séjoumi', 'Sidi Hassine', 'Sidi El Béchir', 
    'Sidi Daoud', 'Sidi Bou Said', 'Médina', 'Mutuelleville', 'Montplaisir',
    'Monfleury', 'Menzah', 'Manar', 'Le Kram', 'Le Bardo', 'Lac 2', 'Lac 1',
    'La Marsa', 'La Goulette', 'L Aouina', 'Ksar Said', 'Kheireddine Pacha', 
    'Khaznadar', 'Jardins De Carthage', 'Hraïria', 'Gammarth', 'Ezzouhour', 
    'Ettahrir', 'El Ouardia', 'El Omrane Supérieur', 'El Omrane', 'El Menzah 9',
    'El Menzah 4', 'El Menzah 1', 'El Manar 2', 'El Manar 1', 'El Kabaria',
    'Djebel Jelloud', 'Cité Olympique', 'Cité jardin', 'Cité El Khadra',
    'Centre Ville Lafayette', 'Centre Urbain Nord', 'Carthage', 'Bellevue',
    'Bab Souika', 'Autre', 'Alain Savary', 'Ain Zaghouen',
    'Ain Zaghouan Sud', 'Ain Zaghouan Nord', 'Agba'
  ],
  Ariana: [
    'Sidi Thabet', 'Riadh Andalous', 'Raoued', 'Nouvelle Ariana', 'Mnihla',
    'Les Jardins El Menzah 2', 'Les Jardins El Menzah 1', 'La Soukra',
    'Kalâat Andalous', 'Jardins El Menzah', 'Ghazela', 'Ettadhamen',
    'Ennasr', 'El Menzah 8', 'El Menzah 7', 'El Menzah 6', 'El Menzah 5',
    'Dar Fadhal', 'Cité Hedi Nouira', 'Cité Ennasr 2', 'Cité Ennasr 1',
    'Cite Ennkhilet', 'Chotrana 3', 'Chotrana 2', 'Chotrana 1', 'Chotrana',
    'Charguia 2', 'Charguia 1', 'Borj Louzir', 'Autre', 'Ariana Ville',
    'Ariana Essoughra', 'Ariana'
  ],
  "Ben Arous": [
    'Sidi Rezig', 'Radès', 'Mégrine', 'Mornag', 'Mohamedia', 'Medina Jedida',
    'Hammam Lif', 'Hammam Chott', 'Fouchana', 'Ezzahra', 
    'El Mourouj 6', 'El Mourouj 5', 'El Mourouj 4', 'El Mourouj 3', 'El Mourouj 1', 
    'El Mourouj', 'Boumhel', 'Borj Cedria', 'Ben Arous', 'Autre'
  ],
  "La Manouba": ['Tebourba', 'Oued Ellil', 'Mornaguia', 'Menzel El Habib',
    'Manouba Ville', 'La Manouba', 'El Battan', 'Douar Hicher', 'Djedeida',
    'Denden', 'Borj El Amri', 'Autre'],
  Nabeul: ['Yasmine Hammamet',
    'Takelsa',
    'Soliman',
    'Nabeul',
    'Mrezga',
    'Menzel Temime',
    'Menzel Bouzelfa',
    'Kélibia',
    'Korba',
    'Hammamet Nord',
    'Hammamet Centre',
    'Hammamet',
    'Hammam Ghezèze',
    'Grombalia',
    'El Mida',
    'El Haouaria',
    'Dar Châabane El Fehri',
    'Béni Khiar',
    'Béni Khalled',
    'Bou Argoub',
    'Autre'],
  Zaghouan: ['Zaghouen',
    'Zaghouan',
    'Saouaf',
    'Ez Zeriba',
    'En Nadhour',
    'El Fahs',
    'Bir Mchergua',
    'Autre'],
  Bizerte: ['Zarzouna',
  'Utique',
  'Tinja',
  'Sejenane',
  'Ras Jebel',
  'Menzel Jemil',
  'Menzel Bourguiba',
  'Mateur',
  'Ghezala',
  'Ghar El Melh',
  'El Alia',
  'Djoumime',
  'Bizerte Sud',
  'Bizerte Nord',
  'Bizerte',
  'Autre'],
  "Béja": ['Téboursouk',
  'Thibar',
  'Testour',
  'Nefza',
  'Medjez El Bab',
  'Goubellat',
  'El Ksar',
  'Béja Sud',
  'Béja Nord',
  'Béja',
  'Amdoun',
  'Autre'],
  Jendouba: ['Tabarka',
  'Oued Meliz',
  'Jendouba Nord',
  'Jendouba',
  'Ghardimaou',
  'Fernana',
  'Bou Salem',
  'Balta Bou Aouane',
  'Ain Draham',
  'Autre'],
  "El Kef": ['Tajerouine',
  'Sakiet Sidi Youssef',
  'Nebeur',
  'Le Kef',
  'Kef Ouest',
  'Kef Est',
  'Kalâat Snan',
  'Kalâat Khasbah',
  'Es Sers',
  'El Ksour',
  'Djerissa',
  'Dahmani',
  'Autre'],
  Siliana: ['Siliana Sud',
  'Siliana Nord',
  'Siliana',
  'Sidi Bou Rouis',
  'Rouhia',
  'Makthar',
  'Kesra',
  'Gaâfour',
  'El Krib',
  'El Aroussa',
  'Bou Arada',
  'Bargou',
  'Autre'],
  Sousse: ['Zaouit Ksibat Thrayett',
  'Sousse Sidi Abdelhamid',
  'Sousse Riadh',
  'Sousse Médina',
  'Sousse Jawhara',
  'Sousse Corniche',
  'Sousse',
  'Sidi El Héni',
  'Sidi Bou Ali',
  'Sahloul',
  'M Saken',
  'Kondar',
  'Khzema',
  'Kantaoui',
  'Kalaâ Sghira',
  'Kalaâ Kebira',
  'Hergla',
  'Hammam Sousse',
  'Enfidha',
  'Chatt Mariem',
  'Bouficha',
  'Akouda',
  'Autre'],
  Monastir: ['Zéramdine',
  'Téboulba',
  'Sayada Lamta Bou Hajar',
  'Sahline',
  'Ouerdanine',
  'Monastir',
  'Moknine',
  'Ksibet El Médiouni',
  'Ksar Hellal',
  'Jemmal',
  'Beni Hassen',
  'Bembla',
  'Bekalta',
  'Autre'],
  Mahdia: ['Sidi Alouane',
  'Ouled Chamekh',
  'Melloulèche',
  'Mahdia',
  'Ksour Essef',
  'Hebira',
  'Essouassi',
  'El Jem',
  'Chorbane',
  'Chebba',
  'Bou Merdès',
  'Autre'],
  Kairouan: ['Sbikha',
  'Nasrallah',
  'Kairouan Sud',
  'Kairouan Nord',
  'Kairouan',
  'Hajeb El Ayoun',
  'Haffouz',
  'El Ouslatia',
  'El Alâa',
  'Echrarda',
  'Chebika',
  'Bouhajla',
  'Autre'],
  Kasserine: ['Kasserine Ville', 'Sbeitla', 'Feriana'],
  "Sidi Bouzid": ['Souk Jedid',
  'Sidi Bouzid Ouest',
  'Sidi Bouzid Est',
  'Sidi Bouzid',
  'Sidi Ali Ben Aoun',
  'Regueb',
  'Ouled Haffouz',
  'Mezzouna',
  'Menzel Bouzaiane',
  'Meknassy',
  'Jilma',
  'Cebbala Ouled Asker',
  'Bir El Hafey',
  'Autre'],
  Sfax: ['Thyna',
  'Skhira',
  'Sfax Ville',
  'Sfax Médina',
  'Sfax',
  'Sakiet Ezzit',
  'Sakiet Eddaïer',
  'Route Tunis',
  'Route TANIOUR',
  'Route Soukra',
  'Route SOKRA',
  'ROUTE SALTANIA',
  'Route MHARZA',
  'Route Menzel Chaker',
  'Route Mehdia',
  'Route MANZEL CHAKER',
  'Route GREMDA',
  'Route El Ain',
  'Route El Afrane',
  "Route de l'aéroport",
  'Route de GABES',
  'Menzel Chaker',
  'Mahrès',
  'Kerkennah',
  'Jebiniana',
  'Ghraiba',
  'El Hencha',
  'El Amra',
  'Bir Ali Ben Khalifa',
  'Autre',
  'Agareb'],
  Gabès: ['Nouvelle Matmata',
  'Métouia',
  'Matmata',
  'Mareth',
  'Ghanouch',
  'Gabès Sud',
  'Gabès Ouest',
  'Gabès Médina',
  'Gabès',
  'El Hamma',
  'Autre'],
  Medenine: ['Zarzis',
  'Wled Amor',
  'Touta',
  'Tezdaine',
  'Temlel',
  'Tawrit',
  'Sidi Makhloulf',
  'M’guersa',
  'Médenine Sud',
  'Médenine Nord',
  'Médenine',
  'Mezzraya',
  'Melita',
  'Mai',
  'Mahboubine',
  'Khazroun',
  'Hedade',
  'Gizen',
  'Fatou',
  'Djerba Midoun',
  'Djerba Houmt Souk',
  'Djerba Ajim',
  'Chebabia',
  'Boughrara',
  'Beni Khedech',
  'Ben Gardane',
  'Autre',
  'Arkou',
  'Aghir'],
  Tataouine: ['Tataouine Sud',
  'Tataouine Nord',
  'Tataouine',
  'Smâr',
  'Remada',
  'Ghomrassen',
  'Dehiba',
  'Bir Lahmar',
  'Autre'],
  Gafsa: ['Sidi Aïch',
  'Sened',
  'Redeyef',
  'Oum El Araies',
  'Métlaoui',
  'Mdhila',
  'Gafsa Sud',
  'Gafsa Nord',
  'Gafsa',
  'El Ksar',
  'El Guettar',
  'Belkhir',
  'Autre'],
  Tozeur: ['Tozeur',
  'Tameghza',
  'Nefta',
  'Hazoua',
  'Degache',
  'Autre'],
  Kebili: ['Souk Lahad',
  'Kébili Sud',
  'Kébili Nord',
  'Kébili',
  'Faouar',
  'Douz Sud',
  'Douz Nord',
  'Autre']
};

